import { company } from '~/company/Company';
import { TimeFormat } from '~/company/interface';

export const TIME_FORMATS = {
  [TimeFormat.h12]: 'hh:mm a',
  [TimeFormat.h24]: 'HH:mm',
};

export const useTimeFormat = () => {
  return {
    timeFormat: TIME_FORMATS[company.config.timeFormat],
  };
};
